import styled from '@emotion/styled';

import * as React from 'react';

import { observer } from 'src/utils/mobx-react';



const SvgElement = styled('svg', { label: 'SvgElement' })`

    height: auto;

`;



interface CopyPropsType {

    className?: string;

    onClick?: (e: React.SyntheticEvent) => void;

}



export const CopyIcon = observer('CopyIcon', ({ className, onClick }: CopyPropsType): JSX.Element => {

    return (

        <SvgElement

            className={className}

            fill='#fff'

            height='16'

            onClick={onClick}

            viewBox='0 0 16 16'

            width='16'

            xmlns='http://www.w3.org/2000/svg'

        >

            <path

                d='M10.6667 13.3335H5.33333C4.8029 13.3335 4.29419 13.1228 3.91912 12.7477C3.54405 12.3726 3.33333 11.8639 3.33333 11.3335V4.66683C3.33333 4.49002 3.2631 4.32045 3.13807 4.19543C3.01305 4.0704 2.84348 4.00016 2.66667 4.00016C2.48986 4.00016 2.32029 4.0704 2.19526 4.19543C2.07024 4.32045 2 4.49002 2 4.66683V11.3335C2 12.2176 2.35119 13.0654 2.97631 13.6905C3.60143 14.3156 4.44928 14.6668 5.33333 14.6668H10.6667C10.8435 14.6668 11.013 14.5966 11.1381 14.4716C11.2631 14.3465 11.3333 14.177 11.3333 14.0002C11.3333 13.8234 11.2631 13.6538 11.1381 13.5288C11.013 13.4037 10.8435 13.3335 10.6667 13.3335ZM14 5.96016C13.9931 5.89892 13.9796 5.83858 13.96 5.78016V5.72016C13.9279 5.65162 13.8852 5.58861 13.8333 5.5335L9.83333 1.5335C9.77822 1.48164 9.71521 1.43888 9.64667 1.40683H9.58667L9.37333 1.3335H6.66667C6.13623 1.3335 5.62753 1.54421 5.25245 1.91928C4.87738 2.29436 4.66667 2.80306 4.66667 3.3335V10.0002C4.66667 10.5306 4.87738 11.0393 5.25245 11.4144C5.62753 11.7894 6.13623 12.0002 6.66667 12.0002H12C12.5304 12.0002 13.0391 11.7894 13.4142 11.4144C13.7893 11.0393 14 10.5306 14 10.0002V6.00016C14 6.00016 14 6.00016 14 5.96016ZM10 3.60683L11.7267 5.3335H10.6667C10.4899 5.3335 10.3203 5.26326 10.1953 5.13823C10.0702 5.01321 10 4.84364 10 4.66683V3.60683ZM12.6667 10.0002C12.6667 10.177 12.5964 10.3465 12.4714 10.4716C12.3464 10.5966 12.1768 10.6668 12 10.6668H6.66667C6.48986 10.6668 6.32029 10.5966 6.19526 10.4716C6.07024 10.3465 6 10.177 6 10.0002V3.3335C6 3.15669 6.07024 2.98712 6.19526 2.86209C6.32029 2.73707 6.48986 2.66683 6.66667 2.66683H8.66667V4.66683C8.66667 5.19726 8.87738 5.70597 9.25245 6.08104C9.62753 6.45612 10.1362 6.66683 10.6667 6.66683H12.6667V10.0002Z'

                fill='fill'

            />

        </SvgElement>

    );

});

